import { call, put } from 'redux-saga/effects';
import UpdateMakeActions from '../redux/UpdateMakeRedux';
import { api } from './api';


export function* updatemakesagas(action: any): Generator<any, void, any> {
  const { make_id, make } = action;
  const response = yield call(api.updateMake, make_id, make);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UpdateMakeActions.updateMakeSuccess(response.data));
  } else {
    yield put(UpdateMakeActions.updateMakeFailure());
  }
}